export function isNotEmpty(variable: any): boolean {
  return (variable !== null && variable !== undefined && variable.toString().trim() !== '' && JSON.stringify(variable) !== '{}' && !Number.isNaN((variable)))
}